const LogoMark = ({ size = 28, className = '' }) => (
  <svg
    viewBox="10 5 85 92"
    width={size}
    height={size}
    fill="none"
    className={className}
  >
    <circle cx="50" cy="42" r="30" stroke="#C9A876" strokeWidth="4" />
    <circle cx="50" cy="42" r="16" stroke="#C9A876" strokeWidth="1.5" opacity="0.45" />
    <circle cx="59" cy="50" r="6" fill="#C9A876" />
    <line x1="63" y1="63" x2="89" y2="91" stroke="#C9A876" strokeWidth="7" strokeLinecap="round" />
  </svg>
);

export default LogoMark;
